import { IdentityParameter } from "@/features/types";
import { LineSheetTab } from "@/features/line-sheet-sets/line-sheet-set.types";
import { calcIdentityUrlPrefix } from "@/features/ui/helpers/fetcher-helpers";
import useSWR, { SWRConfiguration } from "swr";
import useFetcher from "@/utils/use-fetcher";

export interface GetLineSheetTabV2Request {}

export interface GetLineSheetTabV2Response extends LineSheetTab {}

export interface GetLineSheetTabV2PathParameter extends IdentityParameter {
  lineSheetSetId: number;
}

export function getGetLineSheetTabV2Key(
  parameter: GetLineSheetTabV2PathParameter | null,
  request?: GetLineSheetTabV2Request
) {
  if (parameter) {
    const { lineSheetSetId } = parameter;
    let url = calcIdentityUrlPrefix(parameter);
    url += `/line-sheet-sets/${lineSheetSetId}/tabs`;
    return {
      url,
      params: request,
    };
  }
  return null;
}

export default function useGetLineSheetTabV2(
  parameter: GetLineSheetTabV2PathParameter | null,
  request: GetLineSheetTabV2Request = {},
  config: SWRConfiguration = {
    revalidateOnFocus: false,
  }
) {
  const fetcher = useFetcher<GetLineSheetTabV2Request, GetLineSheetTabV2Response>();
  return useSWR(getGetLineSheetTabV2Key(parameter, request), fetcher, config);
}
